export enum DomainType {
  GENERIC = 'GENERIC',
  CUSTOM = 'CUSTOM',
  ROOT = 'ROOT',
  COUNTRY_CODE = 'COUNTRY_CODE'
}
